import type { FC } from "react";

import { Badge, BadgeType, Flex, Skeleton, Text } from "src/components";
import { FontWeight } from "src/theme";
import { useTranslation } from "src/translations";
import { OutageState } from "src/types";

const BADGE_TYPE: Record<OutageState, BadgeType> = {
    [OutageState.Open]: BadgeType.light,
    [OutageState.Finished]: BadgeType.neutral,
    [OutageState.Cancelled]: BadgeType.warning,
} as const;

const BADGE_TEXT: Record<OutageState, string> = {
    [OutageState.Open]: "outage.open",
    [OutageState.Finished]: "outage.finished",
    [OutageState.Cancelled]: "outage.cancelled",
} as const;

type StatusProps = {
    outageState?: OutageState;
    isLoading?: boolean;
};

export const Status: FC<StatusProps> = ({ outageState, isLoading }) => {
    const { t } = useTranslation();

    return (
        <Flex flexDirection="column" gap="0.5rem">
            <Text weight={FontWeight._700}>{t("outageDetail.status")}</Text>
            {isLoading ? <Skeleton width="10rem" /> : <Badge type={BADGE_TYPE[outageState!]} text={t(BADGE_TEXT[outageState!])} />}
        </Flex>
    );
};
